import React, { useState } from 'react';
import {
  Modal,
  Input,
  InputTextArea,
  DatePicker,
  TimePicker,
  Select,
  Space,
  Button,
} from 'tt-ui-lib/core';
import { AddIcon, SearchIcon } from 'tt-ui-lib/icons';
import styles from '../Modals.module.scss';

const CreateNewsletterModal = ({ open, setOpen }) => {
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [emailListOpen, setEmailListOpen] = useState(false);

  return (
    <>
      <Modal
        open={open}
        onClose={() => setOpen(false)}
        title="Create a newsletter"
        maskClosable={false}
      >
        <div className={styles.modalBody}>
          <Space className={styles.formRow}>
            <Input placeholder="Subject" style={{ width: '100%' }} />
            <Select options={[]} placeholder="Select a template" style={{ width: '100%' }} />
          </Space>

          <Input placeholder="Title" />

          <InputTextArea placeholder="Letter text" />

          <Space className={styles.formRow}>
            <DatePicker placeholder="Date" style={{ width: '100%' }} />
            <TimePicker placeholder="Time" style={{ width: '100%' }} />
          </Space>

          <a className="link" onClick={() => setEmailListOpen(true)}>
            View full email list (800)
          </a>

          <Button
            type="link"
            icon={<AddIcon style={{ width: '20px', height: '20px' }} className="icon-blue-fill" />}
          >
            Add file
          </Button>

          <Space className={styles.formRow} style={{ marginTop: '20px' }}>
            <Button type="default" style={{ width: '100%' }} onClick={() => setOpen(false)}>
              Cancel
            </Button>

            <Space style={{ justifyContent: 'flex-end', width: '100%' }}>
              <Button
                type="default"
                style={{ width: '100%' }}
                onClick={() => setDeleteModalOpen(true)}
              >
                Delete
              </Button>
              <Button type="default" style={{ width: '100%' }}>
                Preview
              </Button>
              <Button type="primary" style={{ width: '100%' }} disabled>
                Save
              </Button>
            </Space>
          </Space>
        </div>
      </Modal>

      <Modal
        open={deleteModalOpen}
        onClose={() => setDeleteModalOpen(false)}
        title="Do you really want to delete this newsletter?"
      >
        <Space style={{ marginTop: '20px', justifyContent: 'space-between', width: '100%' }}>
          <Button type="default" onClick={() => setDeleteModalOpen(false)}>
            Cancel
          </Button>
          <Button type="primary">Delete</Button>
        </Space>
      </Modal>

      <Modal open={emailListOpen} onClose={() => setEmailListOpen(false)} title="Full email list">
        <Space className={styles.column}>
          <Input
            placeholder="Search"
            prefix={<SearchIcon style={{ width: '20px', height: '20px' }} />}
            style={{ width: '100%' }}
          />
          <p>list</p>
        </Space>

        <Space style={{ marginTop: '20px', justifyContent: 'space-between', width: '100%' }}>
          <Button type="default" onClick={() => setEmailListOpen(false)}>
            Cancel
          </Button>
          <Button type="primary">Save</Button>
        </Space>
      </Modal>
    </>
  );
};

export default CreateNewsletterModal;
